import React from "react";
import Media from "react-media-universal";
import PropTypes from "prop-types";
import { Breakpoint } from "core-web/utils/mediaqueries";
import { labels } from "./breakpoints";
import { getMinBreakpointValue } from "./calculations";

const Above = ({ breakpoint, render }) => (
    <Breakpoint.Consumer>
        {({ breakpointIndex }) => (
            <Media
                query={{ minWidth: getMinBreakpointValue(breakpoint) }}
                defaultMatches={breakpointIndex >= labels.indexOf(breakpoint)}
                render={render}
            />
        )}
    </Breakpoint.Consumer>
);

Above.propTypes = {
    breakpoint: PropTypes.oneOf(labels).isRequired,
    render: PropTypes.func.isRequired,
};

export default Above;
